import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { DesktopNav, MobileMenu } from "@/components/navbar-parts";

export default function Navbar() {
  const { brandName } = useContent();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${
        scrolled
          ? "bg-[color-mix(in_srgb,var(--brand-cream)_90%,transparent)] backdrop-blur-xl border-[#D8CEBE]"
          : "bg-transparent border-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 sm:px-10 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-logo"
          className="font-display text-2xl sm:text-[1.7rem] leading-none tracking-tight text-[var(--brand-primary)]"
        >
          {brandName}<span className="text-[var(--brand-heading)]">.</span>
        </Link>

        <DesktopNav pathname={location.pathname} />

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-[var(--brand-heading)]"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && <MobileMenu />}
    </header>
  );
}
